import { LayerGroup, WMSTileLayer } from 'react-leaflet'

const mareanoBaseUrl = '//kart.hi.no/mareano/mareano_biologi'

export const MareanoKorallrevVernet: React.FC = () => (
  <LayerGroup>
    <WMSTileLayer
      url={`${mareanoBaseUrl}/korallrev_vernede_omraader/ows`}
      layers="korallrev_vernede_omraader"
      transparent={true}
      zIndex={500}
      format="image/png"
      pane="wms-pane"
    />
  </LayerGroup>
)

export const MareanoKorallrevObservert: React.FC = () => (
  <LayerGroup>
    <WMSTileLayer
      url={`${mareanoBaseUrl}/korallrev_observert_rev/ows`}
      layers="korallrev_observert_rev"
      transparent={true}
      zIndex={500}
      format="image/png"
      pane="wms-pane"
    />
  </LayerGroup>
)

export const MareanoKorallrevModellert: React.FC = () => (
  <LayerGroup>
    <WMSTileLayer
      url={`${mareanoBaseUrl}/korallrev_modellerte_omraader/ows`}
      layers="korallrev_modellerte_omraader"
      transparent={true}
      zIndex={500}
      format="image/png"
      pane="wms-pane"
    />
  </LayerGroup>
)

export const MareanoKorallrevIdentifisert: React.FC = () => (
  <LayerGroup>
    <WMSTileLayer
      url={`${mareanoBaseUrl}/korallrev_identifiserte_omraader/ows`}
      layers="korallrev_identifiserte_omraader"
      transparent={true}
      zIndex={500}
      format="image/png"
      pane="wms-pane"
    />
  </LayerGroup>
)
